import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";
import { niceName, fmtPhone } from "@/lib/format";
import { twilioFor, sendWa } from "@/lib/whatsapp";

// «Lembrar …»: abre sempre a pré-visualização (texto, canal, destinatário); nunca envia sem ver.
export const remindAction = (a) => new Promise((resolve) => window.dispatchEvent(new CustomEvent("imodesk:remind", { detail: { a, resolve } })));

const body = (a) => ({ base_url: window.location.origin, reminder_keys: a.reminder_keys, reminder_doc: a.reminder_doc, reminder_docs: a.reminder_docs });
const btn = "h-10 px-4 rounded-lg text-sm font-semibold whitespace-nowrap";

export function RemindHost() {
  const [cur, setCur] = useState(null);
  const [prev, setPrev] = useState(null);
  const [text, setText] = useState("");
  const [edit, setEdit] = useState(false);
  const [ch, setCh] = useState("whatsapp");
  const [other, setOther] = useState(false);
  useEffect(() => {
    const on = async (e) => {
      const { a } = e.detail;
      setCur(e.detail); setPrev(null); setEdit(false); setOther(false);
      try {
        const { data } = await api.post(`/processes/${a.pid}/portal-links/${a.token}/send`, { ...body(a), channel: a.phone ? "whatsapp" : "copy", preview: true });
        setPrev(data); setText(data.wa_text); setCh(a.phone ? "whatsapp" : data.email ? "email" : "copy");
      } catch (err) { toast.error(apiErr(err.response?.data?.detail)); e.detail.resolve(); setCur(null); }
    };
    window.addEventListener("imodesk:remind", on);
    return () => window.removeEventListener("imodesk:remind", on);
  }, []);
  const close = () => { cur?.resolve(); setCur(null); };
  const send = async () => {
    const a = cur.a;
    const wa = ch === "whatsapp";
    const tw = wa && twilioFor(a.pid);
    const win = wa && !tw ? window.open("", "_blank") : null;
    try {
      const { data } = await api.post(`/processes/${a.pid}/portal-links/${a.token}/send`, { ...body(a), channel: ch, text });
      if (tw) {
        await sendWa(a.pid, a.phone, data.wa_text);
      } else if (wa) {
        const url = `https://wa.me/${a.phone}?text=${encodeURIComponent(data.wa_text)}`;
        if (win) win.location.href = url; else window.location.href = url;
      } else if (ch === "email") {
        toast.success("Email enviado");
      } else {
        await navigator.clipboard.writeText(data.wa_text).catch(() => {});
        toast.success("Mensagem copiada: cole-a no WhatsApp ou no email do cliente.");
      }
      cur.resolve(ch === "whatsapp" || ch === "email"); setCur(null);
    } catch (err) { win?.close(); toast.error(apiErr(err.response?.data?.detail)); }
  };
  return (
    <Dialog open={!!cur} onOpenChange={(v) => !v && close()}>
      <DialogContent className="max-w-lg" data-testid="remind-preview">
        <DialogHeader>
          <DialogTitle className="font-heading text-ec-green">{cur?.a.button || "Pré-visualizar mensagem"}</DialogTitle>
          <DialogDescription>Nada é enviado sem confirmar.</DialogDescription>
        </DialogHeader>
        {!prev ? <p className="text-sm text-slate-400">A preparar…</p> : (
          <div className="space-y-3">
            <div className="text-sm text-slate-600 space-y-0.5">
              <div data-testid="remind-to"><span className="text-slate-400">Para:</span> {(cur?.a.button || "").replace(/^(Lembrar|Pedir (à|ao))\s+/, "") || niceName(prev.to_name) || "cliente"}{prev.phone ? ` · ${fmtPhone(prev.phone)}` : prev.email ? ` · ${prev.email}` : ""}</div>
              <div className="flex items-center gap-1.5 flex-wrap" data-testid="remind-channel"><span className="text-slate-400">Canal:</span>
                {!other ? (
                  <>
                    <span className="font-semibold text-slate-800" data-testid="remind-ch-auto">{{ whatsapp: "WhatsApp", email: "Email", copy: "Copiar a mensagem" }[ch]}</span>
                    <span className="text-xs text-slate-400">{ch === "whatsapp" ? "(tem telemóvel)" : ch === "email" ? "(sem telemóvel)" : "(sem telemóvel nem email)"}</span>
                    <button onClick={() => setOther(true)} className="text-xs text-slate-500 underline underline-offset-2 ml-1" data-testid="remind-ch-other">outro canal</button>
                  </>
                ) : [["whatsapp", "WhatsApp", !!cur?.a.phone], ["email", "Email", !!prev.email], ["copy", "Copiar", true]].filter((x) => x[2]).map(([k, l]) => (
                  <button key={k} onClick={() => setCh(k)} className={`px-2.5 py-0.5 rounded-full border text-xs font-semibold ${ch === k ? "border-green-600 bg-green-50 text-green-800" : "border-slate-200 text-slate-600"}`} data-testid={`remind-ch-${k}`}>{l}</button>
                ))}
              </div>
            </div>
            <textarea value={text} readOnly={!edit} onChange={(e) => setText(e.target.value)} rows={9}
              className={`w-full rounded-lg border px-3 py-2 text-sm leading-relaxed ${edit ? "border-slate-400 bg-white" : "border-slate-200 bg-slate-50 text-slate-700"}`} data-testid="remind-text" />
            <div className="flex justify-end gap-2">
              <button onClick={() => setEdit(!edit)} className={`${btn} border border-slate-300 bg-white text-slate-800 hover:bg-slate-50`} data-testid="remind-edit">{edit ? "Concluir edição" : "Editar"}</button>
              <button onClick={send} disabled={!text.trim()} className={`${btn} inline-flex items-center gap-2 bg-ec-green text-white hover:bg-ec-greenDark disabled:opacity-50`} data-testid="remind-send">{ch === "whatsapp" && <WhatsAppIcon />}{ch === "whatsapp" ? "Enviar por WhatsApp" : ch === "email" ? "Enviar por email" : "Copiar"}</button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
